/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 17:51:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 20:17:02
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/Range/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { NumberInput, Button } from 'src/components/Antd';
import DropDown from '../DropDown';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Range = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    keyWord,
    value,
    min,
    max,
    onConfirm,
    onDropDownChange,
    prefixName,
    dropDownVisible,
  } = props;

  const [from = 0, to = 0] = value || [];
  const [_from, _setFrom] = React.useState(from);
  const [_to, _setTo] = React.useState(to);

  useAfterDidMountEffect(() => {
    if (dropDownVisible) {
      if (from !== _from) {
        _setFrom(from || 0);
      }
      if (_to !== to) {
        if (!to && from > 0) {
          _setTo(to || 0);
          _setFrom(0);
        }
        _setTo(to || 0);
      }
    }
  }, [dropDownVisible]);

  const handleOnConfirm = () => {
    if (onConfirm) {
      onConfirm({
        [keyWord]: [
          {
            label: `${prefixName || 'From'} ${_from}`,
            value: _from,
            relativeValue: [_to],
            invisible: true,
          },
          {
            label: `${prefixName || ''} from ${_from} to ${_to} `,
            value: _to,
            relativeValue: [_from],
          },
        ],
      });
    }
    onDropDownChange(false);
  };

  const handleOnCancel = () => {
    onDropDownChange(false);
  };

  return (
    <div className={css.container}>
      <div className={css.title}>{getI18n('general.range')}</div>
      <div className={css.inputContainer}>
        <NumberInput
          min={min}
          max={_to > max ? max : _to}
          className={css.input}
          onChange={_setFrom}
          value={_from || 0}
        />
        <div className={css.midContainer}>-</div>
        <NumberInput
          min={_from}
          max={max}
          className={css.input}
          value={_to || 0}
          onChange={_setTo}
        />
      </div>
      <div className={css.buttonContainer}>
        <Button onClick={handleOnCancel} className={css.buttonCancel}>
          {getI18n('general.cancel')}
        </Button>
        <Button onClick={handleOnConfirm} className={css.buttonConfirm}>
          {getI18n('general.confirm')}
        </Button>
      </div>
    </div>
  );
};

export default DropDown(Range, {
  name: 'Range',
  maxHeight: 150,
  maxWidth: 250,
});
